import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import orderBy from 'lodash/orderBy';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';


const TableWrapper = styled.div`
width: auto;
overflow-x: auto;
`;

const getStudentData = (studentData) => {
  if (typeof studentData !== 'undefined') {
    const studentArr = Object.keys(studentData)
      .map((studentId) => {
        const data = studentData[studentId];
        return {
          ...data,
          studentId,
        };
      });
    return orderBy(studentArr, student => student.timestamp, 'asc');
  }

  return [];
};

const formattedDate = (timestamp) => {
  const date = new Date(timestamp);
  return `${date.getFullYear()}/${date.getMonth()}/${date.getDate()}-${date.getHours()}:${date.getMinutes()}`;
};


const CandidateTableCard = ({
  studentData,
}) => (
  <TableWrapper>
      <Table
        selectable
        bodyStyle={{
          overflow: 'visible',
        }}
        multiSelectable
      >
        <TableHeader displaySelectAll={false}>
          <TableRow>
            <TableHeaderColumn style={{ width: '20px', paddingLeft: 0 }}>S.No</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '200px' }}>Refrence No</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '200px' }}>Name</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '120px' }}>Roll No</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '160px' }}>Graduation Agg Marks</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '120px' }}>Year of Passing</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '260px' }}>Branch</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '260px' }}>Degree</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '120px' }}>Backlogs</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '160px' }}>Placement Status</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '160px' }}>10th Marks</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '160px' }}>Year of Passing</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '160px' }}>12th Marks</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '160px' }}>Year of Passing</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '260px' }}>Certifications</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '160px' }}>DOB</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '160px' }}>Gender</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '160px' }}>Email</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '160px' }}>Contact</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '160px' }}>Date of Registration</TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody displayRowCheckbox={false}>
          {getStudentData(studentData).map((student, index) => (
            <TableRow key={student.studentId}>
              <TableRowColumn style={{ width: '20px', paddingLeft: 48 }}>{index + 1}</TableRowColumn>
              <TableRowColumn style={{ width: '200px' }}>{student.id}</TableRowColumn>
              <TableRowColumn style={{ width: '200px' }}>{student.candidateName}</TableRowColumn>
              <TableRowColumn style={{ width: '120px' }}>{student.universityRollNo}</TableRowColumn>
              <TableRowColumn style={{ width: '160px' }}>{student.marksGraduation}</TableRowColumn>
              <TableRowColumn style={{ width: '120px' }}>{student.yopGraduation}</TableRowColumn>
              <TableRowColumn style={{ width: '260px' }}>{student.stream}</TableRowColumn>
              <TableRowColumn style={{ width: '260px' }}>{student.degree}</TableRowColumn>
              <TableRowColumn style={{ width: '120px' }}>{student.backlogs}</TableRowColumn>
              <TableRowColumn style={{ width: '160px' }}>{student.placementStatus}</TableRowColumn>
              <TableRowColumn style={{ width: '160px' }}>{student.marks10}</TableRowColumn>
              <TableRowColumn style={{ width: '160px' }}>{student.yop10}</TableRowColumn>
              <TableRowColumn style={{ width: '160px' }}>{student.marks12}</TableRowColumn>
              <TableRowColumn style={{ width: '160px' }}>{student.yop12}</TableRowColumn>
              <TableRowColumn style={{ width: '260px' }}>{student.certifications}</TableRowColumn>
              <TableRowColumn style={{ width: '160px' }}>{student.dateOfBirth}</TableRowColumn>
              <TableRowColumn style={{ width: '160px' }}>{student.gender}</TableRowColumn>
              <TableRowColumn style={{ width: '160px' }}>{student.primaryEmail}</TableRowColumn>
              <TableRowColumn style={{ width: '160px' }}>{student.primaryContact}</TableRowColumn>
              <TableRowColumn style={{ width: '160px' }}>{formattedDate(student.timestamp)}</TableRowColumn>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableWrapper>
  );

CandidateTableCard.propTypes = {
  studentData: PropTypes.array.isRequired, // eslint-disable-line
};


export default CandidateTableCard;



// WEBPACK FOOTER //
// ./src/components/CandidateTableCard/CandidateTableCard.js